import { useState, useCallback } from 'react';
import { api } from '../services/api';
import { InvestorPitch } from '../types';

export function useAIPitch(posterId: string) {
  const [pitch, setPitch] = useState<InvestorPitch | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generatePitch = useCallback(async () => {
    if (!posterId) return;
    
    setLoading(true);
    setError(null);
    try {
      const generatedPitch = await api.generatePitch(posterId);
      setPitch(generatedPitch);
      return generatedPitch;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to generate pitch';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [posterId]);

  const explainSection = useCallback(async (section: string): Promise<string> => {
    if (!posterId) throw new Error('Poster ID is required');
    
    try {
      return await api.explainSection(posterId, section);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to explain section';
      throw new Error(errorMessage);
    }
  }, [posterId]);

  return {
    pitch,
    loading,
    error,
    generatePitch,
    explainSection,
  };
}

